(() => {
  if (window.feDispensersInstalled) return;
  window.feDispensersInstalled = true;
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const packs = { pads: 1200, tampons: 1550, liners: 4800 };
  let calc, catalog, messages, money;
  const manual = new Set();
  const text = (selector, value) => { const el = $(selector, calc); if (el) el.textContent = value; };
  const group = (name) => $(`[data-group="${name}"] [aria-pressed="true"]`, calc);
  const integer = (id) => Number($(`#${id}`, calc).value);
  const format = (key, values = {}) => Object.entries(values).reduce((s, [k, v]) => s.replaceAll(`{${k}}`, String(v)), messages[key]);
  function valid(show = false) {
    let okay = true;
    for (const field of $$('input[type="number"]', calc)) {
      const optional = field.id.startsWith('usage-') || field.id.startsWith('qty-');
      const type = optional ? field.id.split('-')[1] : null;
      if (type && !$(`#include-${type}`, calc).checked) continue;
      const n = Number(field.value);
      const good = field.value.trim() !== '' && Number.isSafeInteger(n) && n >= Number(field.min) && n <= Number(field.max);
      field.setAttribute('aria-invalid', String(!good));
      const error = $(`#${field.id}-error`, calc);
      if (error) error.textContent = good ? '' : format('range', { min: field.min, max: field.max });
      okay = okay && good;
    }
    const error = $('[data-calc-error]', calc);
    error.hidden = okay;
    error.textContent = okay ? '' : messages.invalid;
    if (show && !okay) $('[aria-invalid="true"]', calc)?.focus();
    return okay;
  }
  function state() {
    const count = integer('exact-toilets') * integer('exact-locations');
    const women = integer('exact-women');
    const perDispenser = women / count;
    const choice = $('#model-choice', calc).value;
    const key = choice === 'auto' ? (perDispenser <= 20 ? 'personal' : perDispenser <= 50 ? 'entrepreneur' : 'corporate') : choice;
    return { count, women, key, model: catalog.models[key], onlyRefill: $('#refill-only', calc).checked, months: Number(group('coverage').dataset.value), mode: group('mode').dataset.value };
  }
  function render(recalculate = true) {
    if (!calc) return;
    const add = $('[data-add-dispenser]', calc);
    if (!valid()) { add.disabled = true; text('[data-dispenser-total]', '—'); return; }
    const s = state();
    $('#model-choice', calc).disabled = s.onlyRefill;
    const image = $('[data-result-image]', calc);
    image.hidden = s.onlyRefill || !s.model.image;
    if (s.model.image) image.src = s.model.image;
    image.alt = s.model.name;
    text('[data-result-name]', s.onlyRefill ? messages.refillOnly : s.model.name);
    text('[data-result-count]', s.onlyRefill ? messages.quoteOnly : format('count', { count: s.count, price: money(s.model.price) }));
    for (const [k, size] of Object.entries(packs)) {
      const included = $(`#include-${k}`, calc).checked;
      const row = $(`[data-refill-row="${k}"]`, calc);
      row.hidden = !included;
      const qty = $(`#qty-${k}`, calc);
      if (!included) { qty.value = 0; manual.delete(k); }
      else if (recalculate && !manual.has(k)) qty.value = Math.ceil(s.women * integer(`usage-${k}`) * s.months / size);
      text(`[data-consumption="${k}"]`, format('consumption', { monthly: s.women * integer(`usage-${k}`), pack: size }));
      text(`[data-pieces="${k}"]`, format('pieces', { count: Number(qty.value) * size }));
    }
    text('[data-dispenser-total]', s.onlyRefill ? money(0) : s.model.id ? money(s.count * s.model.price) : messages.quoteOnly);
    const canBuy = !s.onlyRefill && s.mode === 'once' && s.model.id && s.model.available;
    add.disabled = !canBuy;
    $('[data-cart-id]', calc).value = s.model.id || '';
    $('[data-cart-qty]', calc).value = s.count;
    text('[data-calc-status]', s.mode !== 'once' || s.onlyRefill ? messages.quoteOnly : !s.model.available ? messages.unavailable : messages.dispensersOnly);
  }
  function setup() {
    calc = $('[data-fed-section="config"]');
    if (!calc) return;
    try {
      catalog = JSON.parse($('[data-fed-catalog]', calc).textContent);
      messages = JSON.parse($('[data-fed-messages]', calc).textContent);
    } catch { calc = null; return; }
    const formatter = new Intl.NumberFormat(catalog.locale, { style: 'currency', currency: catalog.currency });
    money = cents => formatter.format(cents / 100);
    render();
    if (location.hash === '#config') $('#calculator-panel', calc).open = true;
  }
  function quote() {
    if (!valid(true)) return;
    const s = state();
    const lines = [messages.summary, `${group('space').textContent.trim()} · ${group('mode').textContent.trim()}`, format('people', { women: s.women, toilets: integer('exact-toilets'), locations: integer('exact-locations') }), group('coverage').textContent.trim()];
    lines.push(s.onlyRefill ? messages.refillOnly : `${s.count} × ${s.model.name} · ${money(s.count * s.model.price)}`);
    for (const [k, size] of Object.entries(packs)) {
      if ($(`#include-${k}`, calc).checked) lines.push(`${$(`[data-refill-row="${k}"] h4`, calc).textContent}: ${format('boxes', { count: integer(`qty-${k}`) })} (${integer(`qty-${k}`) * size})`);
    }
    lines.push(messages.quoteOnly);
    const contact = $('[data-fed-section="contact"]');
    if (!contact) return;
    $('#estimate-summary', contact).value = lines.join('\n');
    $('#estimate-box', contact).hidden = false;
    contact.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    $('#name', contact).focus({ preventScroll: true });
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('button,a');
    if (!trigger?.closest('.fe-dispensers')) return;
    if (trigger.id === 'load-video') {
      const frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/fPm5zo1uhO8?autoplay=1&rel=0';
      frame.title = trigger.getAttribute('aria-label');
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      $('#video-stage').replaceChildren(frame);
      return;
    }
    if (!calc) return;
    if (trigger.getAttribute('href') === '#config' || trigger.dataset.configure) {
      $('#calculator-panel', calc).open = true;
      if (trigger.dataset.configure) {
        $('#model-choice', calc).value = trigger.dataset.configure;
        $('#refill-only', calc).checked = false;
        render();
        $('#config', calc).scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    }
    const seg = trigger.closest('[data-group]');
    if (seg && calc.contains(seg)) {
      $$('button', seg).forEach(b => b.setAttribute('aria-pressed', String(b === trigger)));
      render();
    }
    if (trigger.dataset.adjust) {
      const k = trigger.dataset.adjust;
      const qty = $(`#qty-${k}`, calc);
      qty.value = Math.min(Number(qty.max), Math.max(0, (Number(qty.value) || 0) + Number(trigger.dataset.step)));
      manual.add(k); render(false);
    }
    if (trigger.id === 'reset-quantities') { manual.clear(); $$('[data-qty]', calc).forEach(q => { q.value = 0; }); render(); }
    if (trigger.hasAttribute('data-request-quote')) quote();
  });
  document.addEventListener('input', event => {
    if (!calc?.contains(event.target)) return;
    if (event.target.dataset.qty) manual.add(event.target.dataset.qty);
    if (event.target.matches('input')) render();
  });
  document.addEventListener('change', event => {
    if (calc?.contains(event.target) && event.target.matches('select')) render();
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-config-cart]')) {
      if (!valid(true) || $('[data-add-dispenser]', calc).disabled) event.preventDefault();
    }
  });
  document.addEventListener('shopify:section:load', setup);
  setup();
})();
